export const getProductAttributes = ({
  attributes: {
    brandLogoUrl: [brandLogoUrl] = [],
    brandName: [brandName] = [],
    frontTire: [{ frontTireSkuId: skuId } = {}] = [],
    rearTire: [{ rearTireSkuId: rearSkuId } = {}] = [],
    imageUrl: [imageUrl] = [],
    staggeredSkuId: [staggeredSkuId] = [],
    tireDetailUrl: [tireDetailUrl] = [],
    tireLineName: [tireLineName] = [],
    staggeredSku: [staggeredSku] = []
  } = {}
} = {}) => ({
  brandLogoUrl,
  brandName,
  imageUrl,
  skuId,
  rearSkuId,
  staggeredSkuId,
  tireDetailUrl,
  tireLineName,
  staggeredSku
})

export const getInventoryStatus = (inventoryInfo) => {
  switch (inventoryInfo.availability) {
    case 'today': return { availableToday: true }
    case 'tomorrow': return { availableTomorrow: true }
    case 'later': return { availableAsOf: inventoryInfo.availableDate }

    default: return {}
  }
}
